/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { TreeItem, TreeView } from "@mui/lab";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import SyncIcon from "@mui/icons-material/Sync";

import useGetPageInfo from "../../../common/hooks/useGetPageInfo";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";
import { ioKindList } from "../../../middleware/enums";
import DefaultApiService from "../../../../infrastructure/api/default";
import LoadingWrapper from "../../../components/shared/loading";

const getTreeItemsFromData = (treeItems, parentId) => {
  return treeItems.map((treeItemData) => {
    let children;
    if (treeItemData.children && treeItemData.children.length > 0) {
      children = getTreeItemsFromData(
        treeItemData.children,
        `${parentId}-${treeItemData.id}`
      );
    }

    return (
      <TreeItem
        key={`${parentId}-${treeItemData.id}`}
        nodeId={`${parentId}-${treeItemData.id}`}
        label={treeItemData.title}
        children={children}
      />
    );
  });
};

const onGetChildIds = (node, prev) => {
  if (node?.children?.length > 0) {
    let ids = [];
    for (let i = 0; i < node.children.length; i++) {
      const item = node.children[i];
      ids = [
        ...ids,
        `${prev}-${node.id}`,
        ...onGetChildIds(item, `${prev}-${node.id}`),
      ];
    }
    return ids;
  } else {
    return [];
  }
};

const onFindNodeId = (list, ids) => {
  const currentId = ids[0];
  const otherIds = ids.slice(1);
  if (list.length > 0) {
    const item = list.find((x) => x.id === currentId);
    if (item) {
      if (otherIds.length > 0) {
        return onFindNodeId(item.children, otherIds);
      } else {
        return item;
      }
    }
  }

  return null;
};

const EnergyTreePage = () => {
  const pageInfo = useGetPageInfo();
  const [data, setData] = useState([]);
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterValues, setFilterValues] = useState({ ioKind: 0 });
  const [expanded, setExpanded] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (data.length === 0) onGetDataByFilter();
  }, []);

  const onGetDataByFilter = async (params) => {
    setLoading(true);
    setContent([]);
    const res = await DefaultApiService.getApi("GV/EnergyTree/GetData", params);

    setLoading(false);
    setData(res.data || []);
  };

  const onNodeFocus = (e, nodeId) => {
    const ids = nodeId.split("-");
    setSelected([nodeId]);

    let finalList = [];
    if (expanded.find((x) => x === nodeId)) {
      finalList = expanded.filter((node) => node !== nodeId);
    } else {
      if (ids.length === 2) {
        const node = data.find((x) => x.id === ids[1]);
        const childIds = onGetChildIds(node, ids[0]);
        finalList = [...childIds];
      } else finalList = [...expanded, nodeId];
    }

    setExpanded(finalList);
  };

  const onNodeSelect = (e, nodeId) => {
    const ids = nodeId.split("-");

    const node = onFindNodeId(data, ids.slice(1));

    if (node?.energyInfo) {
      setContent([{ ...node.energyInfo, title: node.title }]);
    } else {
      setContent([]);
    }
  };

  return (
    <Grid container spacing={3} className="gv-view-container ">
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title || "درخت انرژی"}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <RadioGroup
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                  value={filterValues.ioKind}
                  onChange={(event) => {
                    const params = {
                      ...filterValues,
                      ioKind: event.target.value,
                    };
                    setFilterValues((old) => params);
                    onGetDataByFilter(params);
                  }}
                  name="radio-buttons-group"
                >
                  {ioKindList.map((x) => (
                    <FormControlLabel
                      value={x.value}
                      control={<Radio size="small" />}
                      label={x.name}
                    />
                  ))}
                </RadioGroup>

                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  sx={{ mx: 1 }}
                />

                <IconButton
                  variant="text"
                  color="primary"
                  onClick={() => onGetDataByFilter(filterValues)}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Paper
                  elevation={3}
                  sx={{
                    p: 2,
                    height: "70vh",
                    overflow: "auto",
                    boxShadow: "0px 12px 21px 2px rgba(218, 230, 249, 0.4)",
                  }}
                >
                  {loading ? (
                    <LoadingWrapper />
                  ) : (
                    <TreeView
                      defaultCollapseIcon={<ExpandMoreIcon />}
                      defaultExpandIcon={<ChevronLeftIcon />}
                      selected={selected}
                      onNodeSelect={onNodeSelect}
                      expanded={expanded}
                      onNodeFocus={onNodeFocus}
                    >
                      {getTreeItemsFromData(data, "node" + filterValues.ioKind)}
                    </TreeView>
                  )}
                </Paper>
              </Grid>

              <Grid item xs={12} md={8}>
                {content.length > 0 &&
                  content.map((info) => (
                    <Grid
                      item
                      xs={12}
                      md={12}
                      container
                      className="custom-table"
                    >
                      <Grid item xs={12} md={12} className="row header">
                        <Typography
                          variant="h6"
                          fontWeight={"bold"}
                          color={"primary"}
                        >
                          {info.title}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={12} className="row" container>
                        <Grid item xs={12} md={6} container>
                          <Grid item xs={6} md={6} className="cell title">
                            مالکیت ایستگاه
                          </Grid>
                          <Grid item xs={6} md={6} className="cell value">
                            {info.companyName}
                          </Grid>
                        </Grid>

                        <Grid item xs={12} md={6} container>
                          <Grid item xs={6} md={6} className="cell title">
                            تبادل با
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            md={6}
                            className="cell value"
                          ></Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} md={12} className="row" container>
                        <Grid item xs={12} md={6} container>
                          <Grid item xs={6} md={6} className="cell title">
                            شهرستان
                          </Grid>
                          <Grid item xs={6} md={6} className="cell value">
                            {info.cityName}
                          </Grid>
                        </Grid>

                        <Grid item xs={12} md={6} container>
                          <Grid item xs={6} md={6} className="cell title">
                            نام ایستگاه
                          </Grid>
                          <Grid item xs={6} md={6} className="cell value">
                            {info.substationName}
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} md={12} className="row" container>
                        <Grid item xs={12} md={6} container>
                          <Grid item xs={6} md={6} className="cell title">
                            جمع/کسر
                          </Grid>
                          <Grid item xs={6} md={6} className="cell value">
                            {info.powerBasketFactor}
                          </Grid>
                        </Grid>

                        <Grid item xs={12} md={6} container>
                          <Grid item xs={6} md={6} className="cell title">
                            ورودی/خروجی
                          </Grid>
                          <Grid item xs={6} md={6} className="cell value">
                            {info.ioKind}
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} md={12} className="row" container>
                        <Grid item xs={12} md={6} container>
                          <Grid item xs={6} md={6} className="cell title">
                            سریال کنتور
                          </Grid>
                          <Grid item xs={6} md={6} className="cell value">
                            {info.counterSerial}
                          </Grid>
                        </Grid>

                        {info.transNumber && (
                          <Grid item xs={12} md={6} container>
                            <Grid item xs={6} md={6} className="cell title">
                              ترانس
                            </Grid>
                            <Grid item xs={6} md={6} className="cell value">
                              {info.transNumber}
                            </Grid>
                          </Grid>
                        )}
                      </Grid>

                      {info.feederName && (
                        <Grid item xs={12} md={12} className="row" container>
                          <Grid item xs={12} md={6} container>
                            <Grid item xs={6} md={6} className="cell title">
                              فیدر
                            </Grid>
                            <Grid item xs={6} md={6} className="cell value">
                              {info.feederName}
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                  ))}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default EnergyTreePage;
